import gql from 'graphql-tag'

export const GET_CDM_RAW_ALERTS = gql`
  query RawAlerts($filter: GetRawAlertFilter) {
    rawAlerts(filter: $filter) {
      isSuccessful
      message
      status
      rawAlerts {
        data {
          rawAlertId
          vehicleId
          alertCode
          alertRuleIds
          alert {
            descriptionEng
            descriptionIdn
          }
          alertRule {
            label
          }
          sourceDeviceCategory
          sourceDeviceType
          vehicle {
            id
            licensePlate
          }
          latitude
          longitude
          address
          userLogs {
            typeField
            data
            createdOn
            user {
              fullname
            }
            userId
          }
          isFalseAlert
          alertTrigger
          alertData
          isImportant
          isUrgent
          isRead
          lastUserFeedback {
            feedback
            createdOn
            user {
              fullname
            }
          }
          createdOn
          formattedAlertData
        }
        pagination {
          actualTotal
          page
          show
          total
        }
        aggregate {
          eachAlertTotal {
            alertCode
            total
          }
        }
      }
    }
  }
`
